<template lang="pug">

    table.ui.table

        thead
            tr
                th(style='cursor: pointer; user-select: none;' v-on:click='$emit("toggle-sort")')
                    | ZMÜK-ID
                    i.icon(v-bind:class='sortAscending ? "sort amount up" : "sort amount down"')
                th Status
                th Produktart
                th Varianten
                th Angebotsabgabe bis
                th Liefertermin
                th DU-Termin
                th Medienproduktioner

        tbody

            tr(
                v-for='jobModel in jobModels'
                is='row'
                v-bind:key='jobModel.id'
                v-bind:job-model='jobModel'
                v-bind:media-production-person-models='mediaProductionPersonModels'
                v-bind:media-production-user-models='mediaProductionUserModels'
                v-bind:offer-models='offerModels'
                v-bind:product-models='productModels'
                v-bind:product-types='productTypes'
                v-bind:variant-models='variantModels'
            )

</template>

<script>
    import Row from './table/Row'

    export default {

        components: { Row },

        props: {

            jobModels: {
                type: Array,
                required: true
            },

            mediaProductionPersonModels: {
                type: Array,
                required: true
            },

            mediaProductionUserModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            productModels: {
                type: Array,
                required: true
            },

            // TODO checken ob `productTypeModels`
            productTypes: {
                type: Array,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

            sortAscending: {
                type: Boolean,
                default: false
            }

        }

    }

</script>
